import ComboBox from '../../ComboBox';
import { IComboboxSelectedChangeEventArgs } from '@bimser/components';

export interface ITextBoxProps {
	onValueChange: (data: any) => void;
	changeItems?: (items: any) => void;
}
export default class OvverideComboBox extends ComboBox {
	readonly props: ITextBoxProps;
	constructor(props?: ITextBoxProps) {
		super();
		this.props = props;
	}

	triggerValueChanged(args: IComboboxSelectedChangeEventArgs) {
		if (this.props.onValueChange) {
			this.props.onValueChange(args.data);
		}
	}

	__triggerPropertyChanging(value: any, path: string[]) {
		if (this.props.changeItems && path[0] === 'items') {
			this.props.changeItems(value);
		}
	}
}
